import axios from 'axios';

export default async ({ pageParam = 1 }) => await axios.get(`/api/learner/live_videos?page=${pageParam}`);
